export default __webpack_public_path__ + "static/media/logout.b2551934.svg";